import React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import PageTitle from '@components/snippets/PageTitle';

import BasicSettings from './BasicSettings';
import AccountSettings from './AccountSettings';
import CompanySettings from './CompanySettings';
import LicenseSettings from './LicenseSettings';
import useBasicSettings from './hooks/useBasicSettings';
import useAccountSettings from './hooks/useAccountSettings';
import useCompanySettings from './hooks/useCompanySettings';
import useLicense from '../../hooks/useLicense';

function SettingsPage(props) {
  const { t } = useTranslation();

  const {
    loading: basicSettingsLoading,
    pending: basicSettingsPending,
    values: basicSettingsValues,
    save: basicSettingsSave,
  } = useBasicSettings();

  const {
    loading: accountSettingsLoading,
    pending: accountSettingsPending,
    values: accountSettingsValues,
    save: accountSettingsSave,
  } = useAccountSettings();

  const {
    loading: companySettingsLoading,
    pending: companySettingsPending,
    values: companySettingsValues,
    save: companySettingsSave,
  } = useCompanySettings();

  const { changeMode } = useLicense();

  const handleChangeLicenseMode = () => {
    changeMode('manual');
  };

  return (
    <div className="settings-page">
      <PageTitle title={t('settings')} />
      <Row gutter={24}>
        <Col span={8}>
          <Row gutter={[22, 24]}>
            <Col span={24}>
              <BasicSettings
                loading={basicSettingsLoading}
                pending={basicSettingsPending}
                settings={basicSettingsValues}
                onSave={basicSettingsSave}
              />
            </Col>
            <Col span={24}>
              <AccountSettings
                loading={accountSettingsLoading}
                pending={accountSettingsPending}
                settings={accountSettingsValues}
                onSave={accountSettingsSave}
              />
            </Col>
          </Row>
        </Col>
        <Col span={16}>
          <Row gutter={[22, 24]}>
            <Col span={24}>
              <CompanySettings
                loading={companySettingsLoading}
                pending={companySettingsPending}
                settings={companySettingsValues}
                onSave={companySettingsSave}
              />
            </Col>
            <Col span={24}>
              <LicenseSettings
                loading={basicSettingsLoading}
                data={basicSettingsValues}
                onChangeMode={handleChangeLicenseMode}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}

export default SettingsPage;
